import { now } from '../../src/config/SiteConfig';
import best from '../images/best.svg';

export default [
	// {
	// 	title: 'Starter Package',
	// 	subTitle: 'First Four Modules & The Basics.',
	// 	options: {
	// 		price: '64',
	// 		regular_price: '99',
	// 		buyText: 'Buy the Starter Package',
	// 		productId: 544744,
	// 		gray: true,
	// 	},
	// 	features: [
	// 		'<strong>ACCESS</strong><span>:</span><span class="ftr">First Four Modules</span>',
	// 		'<strong>VIDEOS</strong><span>:</span><span class="ftr">First 30 VSCode Videos</span>',
	// 		'<strong>EXPIRY</strong><span>:</span><span class="ftr">Single One Time Payment</span>',
	// 		'<strong>UPDATES</strong><span>:</span><span class="ftr">Lifetime Free Course Updates</span>',
	// 		'<strong>EXAMPLES</strong><span>:</span><span class="ftr">Over 200 VSCode Tips & Tricks</span>',
	// 		'<strong>COMMUNITY</strong><span>:</span><span class="ftr">VSCODEpro Slack Free Access</span>',
	// 		'<strong>VALUE FOR MONEY</strong><span>:</span><span class="ftr">14 days refund (no Q/A)',
	// 	],
	// 	modules: ['Basics Yoga', 'Settings Ninja', 'Power User Workflows', 'HTML/CSS The Web Dev'],
	// },
	{
		title: 'Master Class',
		subTitle: 'All Nine Modules & Everything. This is the package you should buy to become a VSCode Power User.',
		img: best,
		options: {
			price: now,
			regular_price: '149',
			buyText: 'Buy the Master Class',
			productId: 544745,
			green: true,
		},
		features: [
			'<strong>RECOMMENDED!</strong>',
			'<strong>ACCESS</strong><span>:</span><span class="ftr">All Nine Modules</span>',
			'<strong>VIDEOS</strong><span>:</span><span class="ftr">All 65 VSCode Videos</span>',
			'<strong>EXPIRY</strong><span>:</span><span class="ftr">Single One Time Payment</span>',
			'<strong>UPDATES</strong><span>:</span><span class="ftr">Lifetime Free Course Updates</span>',
			'<strong>EXAMPLES</strong><span>:</span><span class="ftr">Over 200 VSCode Tips & Tricks</span>',
			'<strong>COMMUNITY</strong><span>:</span><span class="ftr">VSCODEpro Slack Free Access</span>',
			'<strong>EVERYTHING</strong><span>:</span><span class="ftr">Including all lessons & modules</span>',
			'<strong>VALUE FOR MONEY</strong><span>:</span><span class="ftr">14 days refund (no Q/A)',
		],
		modules: [
			'Basics Yoga',
			'Settings Ninja',
			'Power User Workflows',
			'HTML/CSS The Web Dev',
			'Git/GitHub & OSS Tips',
			'Pro Markdown Workflow',
			'Everything About JavaScript',
			'PHP/WordPress Workflows',
			'50+ Pro Extensions Setup',
		],
	},
];
